import * as types from "../types/combos"

const initialState = []

const combosReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_ALL_COMBOS:
      return [...action.combos]
    case types.UPDATE_COMBOS: {
      const newCombosMap = {}
      action.newCombos.forEach(newCombo => {
        newCombosMap[newCombo._id] = { ...newCombo }
      })

      return state.map(combo =>
        !!newCombosMap[combo._id]
          ? newCombosMap[combo._id]
          : combo
      )
    }
    case types.UPDATE_COMBO:
      return state.map(combo =>
        combo._id === action.newCombo._id ?
          action.newCombo : combo
      )
    case types.ADD_COMBO:
      return [...state, action.newCombo]
    case types.DELETE_COMBO:
      return state.filter(combo =>
        combo._id !== action.comboId
      )
    case types.CLEAR_COMBOS:
      return []
    default:
      return state
  }
}

export default combosReducer